import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {createNotification} from "app/actions/notifications";
import {valueFromTarget} from "lib/form";
import useAppContext from "lib/hooks/use-app-context";

export default function useForm({actions, defaults, path}) {
  const {dispatch} = useAppContext();
  const {id} = useParams();
  const navigate = useNavigate();
  const [record, setRecord] = useState(defaults);

  useEffect(() => {
    if(!id || !actions.get) { return; }

    actions.get(id).then((data) => setRecord(data.record));
  }, [id]);

  const onChange = (e) => {
    const {name} = e.target;
    setRecord({...record, [name]: valueFromTarget(e.target)});
  };

  const onDestroy = () => {
    if(!window.confirm("You sure?")) { return; } // eslint-disable-line no-alert

    actions.destroy(id).then(({message, errors}) => {
      if(errors) { return dispatch(createNotification({content: errors.join(", "), type: "error"})); }

      dispatch(createNotification({content: message}));
      navigate(path);
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const request = id ? actions.update(id, record) : actions.create(record);

    request.then(({message, errors}) => {
      if(errors) { return dispatch(createNotification({content: errors.join(", "), type: "error"})); }

      dispatch(createNotification({content: message}));
      navigate(path);
    });
  };

  return {id, onChange, onDestroy, onSubmit, record, setRecord};
}
